import { type FC, useCallback } from "react";
import { Heading, Link, LinkKind, Text } from "@stubhub/broadway-web";
import { FanProtectFillIcon } from "@stubhub/broadway-web/icons/functional";
import { Content, FormatContent } from "src/shared/components/content";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useAppContext } from "src/shared/context/AppContext";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { useIsStubhub } from "src/shared/utils/appContextHelper";
import { UrlConfigurationType, writeAbsoluteUrl, writeUrl } from "src/shared/utils/url-builder";
import {
  FAN_PROTECT_TRADEMARK,
  VIAGOGO_GUARANTEE_CONTENT_ID,
} from "src/website-apps/shared/components/brand-guarantee/constants";
import { BenefitGrid } from "./BenefitGrid";
import { contentIds } from "./contentIds";
import { detailBodyRecipe, iconTile } from "./styles";

export const DetailBody: FC = () => {
  const appContext = useAppContext();
  const storePageEvent = useStorePageEvent();
  const isStubhub = useIsStubhub();
  const styles = detailBodyRecipe();
  const detailsHref = isStubhub
    ? writeUrl("/promise", null, appContext)
    : writeAbsoluteUrl(
        "/articles/61000309340-what-is-the-viagogo-guarantee",
        null,
        "",
        UrlConfigurationType.SUPPORT,
        appContext,
      );

  const handleSeeDetailsClick = useCallback(() => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.FAN_PROTECT_MODULE_SEE_DETAILS_CLICK, "");
  }, [storePageEvent]);

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <div className={iconTile}>
          <FanProtectFillIcon size={32} />
        </div>
        <div className={styles.textBlock}>
          <Heading>
            {isStubhub ? (
              /* "FanProtect™ Guarantee" */
              <FormatContent id={contentIds.guaranteeTitle} params={[FAN_PROTECT_TRADEMARK]} />
            ) : (
              /* "viagogo Guarantee" */
              <Content id={VIAGOGO_GUARANTEE_CONTENT_ID} />
            )}
          </Heading>
          <Text variant="body" size="small" color="text.subtle">
            {/* "Your order is 100% guaranteed" */}
            <Content id={contentIds.guaranteeDesc} />
          </Text>
        </div>
      </div>
      <BenefitGrid />
      <Text size="small" color="text.subtle">
        <Link
          href={detailsHref}
          kind={LinkKind.Ghost}
          onClick={handleSeeDetailsClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          {/* "See Details" */}
          <Content id={contentIds.seeDetailsLink} />
        </Link>
      </Text>
    </div>
  );
};
